/**
 * RulesPhase — the "Rules" tab on the tournament page.
 * The event's admins (owner, co-admins, Super Admins) get the editor;
 * everyone else reads the live rulebook.
 */
import { useCallback, useEffect, useState } from 'react';
import RulebookEditor from './RulebookEditor';
import RulesView from './RulesView';
import { getCatalogue, rulebookApi, errorText } from './api';

export default function RulesPhase({ event, initialData }) {
  const [data, setData] = useState(initialData || null);
  const [catalogue, setCatalogue] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const [cat, rb] = await Promise.all([getCatalogue(), rulebookApi.get(event.id)]);
      setCatalogue(cat);
      setData(rb);
      setError('');
    } catch (e) {
      setError(errorText(e, "Couldn't load the rules."));
    }
  }, [event.id]);

  useEffect(() => { load(); }, [load]);

  if (error) {
    return (
      <div className="bg-white rounded-2xl p-6 text-center shadow-sm border border-gray-100">
        <p className="text-sm text-gray-600">{error}</p>
        <button onClick={load} className="mt-3 h-10 px-4 rounded-xl bg-[#2B3A67] text-white text-sm font-bold">Try again</button>
      </div>
    );
  }
  if (!data || !catalogue) return <div className="h-40 rounded-2xl bg-white animate-pulse" />;
  // can_manage is false once the tournament is completed (read-only until a Super Admin reopens it)
  if (data.can_manage) return <RulebookEditor event={event} data={data} catalogue={catalogue} onChange={setData} />;
  return <RulesView event={event} data={data} catalogue={catalogue} />;
}
